module.exports = __webpack_public_path__ + "static/media/yarn.7ce48c0e.lock";